import "./CurrencySelectDrawer.scss"
import React, {useEffect, useState} from "react";
import {Drawer, Flex, Radio, RadioChangeEvent, Tooltip} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {useCurrencyConvert, useCurrencyState} from "../../store/CurrencyState";
import {ICrossCurrency} from "../../interfaces/ICrossCurrency";
import {useUnitMinPrice, useUnitsState} from "../../store/UnitsState";

export function CurrencySelectDrawer() {
  const [rates, setRates] = useState<ICrossCurrency[]>([])
  const [currency, setCurrency] = useState<ICrossCurrency | undefined>(undefined)
  const [min, setMin] = useState<number>(0)

  const currencyState = useCurrencyState()
  const unitsState = useUnitsState()
  const unitsMinPrice = useUnitMinPrice()

  const convert = useCurrencyConvert()

  useEffect(() => {
    if (!currencyState.loading && !unitsState.loading) {
      setRates(currencyState.rates)
      setCurrency(currencyState.currentCurrency)
      setMin(unitsMinPrice)
    }
  }, [currencyState, unitsState]);

  const onClose = () => {
    currencyState.closeDrawer()
  }

  const onChange = (e: RadioChangeEvent) => {
    const c = e.target.value as ICrossCurrency
    setCurrency(c)
    currencyState.setCurrentCurrency(c)
  };

  const Buttons = () => rates.map(r => <Tooltip title={r.currency_code}>
    <Radio.Button value={r}>{r.currency_symbol}</Radio.Button>
  </Tooltip>)

  return <Drawer
    title="Обрати валюту"
    placement="bottom"
    onClose={onClose}
    open={currencyState.drawerOpen}
    styles={{header: {textAlign: "center"}}}
    closeIcon={false}
    extra={<CloseOutlined onClick={() => onClose()}/>}>
    <Flex vertical={false} justify={"space-between"} align={"center"}>
      <strong>від {convert(min)} {currency?.currency_code}</strong>
      <Radio.Group onChange={onChange} value={currency}>
        <Buttons/>
      </Radio.Group>
    </Flex>
    <br/>
    {currency?.currency_code !== 'USD' ?
      <p>Ціни перерахувано за курсом {currency?.exchange_rate.toFixed(2)} {currency?.currency_code}/$</p> : null}
    <p>Оновлення: {currency?.created_at}</p>
  </Drawer>
}